// extracted by mini-css-extract-plugin
export var active = "Tab-module--active--49697";
export var anchorTag = "Tab-module--anchorTag--9cee7";
export var tab = "Tab-module--tab--94334";
export var tabItem = "Tab-module--tabItem--f68ab";